document.addEventListener("DOMContentLoaded", () => {
  const productDataEl = document.querySelector("[data-product]");
  if (!productDataEl) return;
  const productData = JSON.parse(productDataEl.textContent);
  const allVariants = productData.variants || [];

  const variantInputs = document.querySelectorAll("input.product-variant-id");

  variantInputs.forEach((input) => {
    input.addEventListener("change", () => {
      const selectedId = parseInt(input.value, 10);
      const variant = allVariants.find((v) => v.id === selectedId);
      if (!variant) return;

      document.querySelectorAll('input[name="properties[_erp_sku]"]').forEach((erpInput) => {
        erpInput.value = variant?.metafields?.custom?.erp_sku || "";
      });

      document.querySelectorAll('input[name="properties[material]"]').forEach((matInput) => {
        matInput.value = variant?.metafields?.custom?.material || "";
      });
    });
  });
});